/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { CallerType } from '../../models/caller-type';

export interface GetSeatmapSvg$Params {
  cartId?: string;
  orderId?: string;
  flightId: string;
  currencyCode?: string;
  departureDateTime?: string;
  version?: number;
  locale?: string;
  Caller?: CallerType;
}

export function getSeatmapSvg(http: HttpClient, rootUrl: string, params: GetSeatmapSvg$Params, context?: HttpContext): Observable<DapiHttpResponse<string>> {
  const rb = new DapiRequestBuilder(rootUrl, getSeatmapSvg.PATH, 'get');

  if (params) {
    rb.query('cartId', params.cartId, {});
    rb.query('orderId', params.orderId, {});
    rb.query('flightId', params.flightId, {});
    rb.query('currencyCode', params.currencyCode, {});
    rb.query('departureDateTime', params.departureDateTime, {});
    rb.query('version', params.version, {});
    rb.query('locale', params.locale, {});
    rb.header('Caller', params.Caller, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/svg+xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<string>;
    }),
    catchErrorAsJson()
  );
}

getSeatmapSvg.PATH = '/api/seatmap/svg';
